<h2 mat-dialog-title>Site #{{ site.id }}</h2>

<mat-dialog-content>
  <table class="w-full table-fixed border-collapse border border-gray-400 ...">
    <thead>
      <tr>
        <th class="w-100 border border-gray-300 p-2"></th>
        <th class="w-1/5 border border-gray-300 p-2">Données source</th>
        <th class="w-1/5 border border-gray-300 p-2">Données normalisées</th>
        <th class="w-1/5 border border-gray-300 p-2">Données fiabilisées automatiquement</th>
        @if (site.dateCheckedByHuman) {
        <th class="w-1/5 border border-gray-300 p-2">Données fiabilisées manuellement</th>
        }
      </tr>
    </thead>
    <tbody>
      @for (field of dataFields; track field) {
      <tr>
        <td class="border border-gray-300 p-2 font-semibold">{{ field.label }}</td>
        <td class="border border-gray-300 p-2">{{ site.sourceAddress[field.key] ?? '-' }}</td>

        <td
          class="border border-gray-300 p-2"
          [class.bg-yellow-100]="site.sourceAddress[field.key] != site.normalizedAddress?.[field.key]">
          {{ site.normalizedAddress?.[field.key] ?? '-' }}
        </td>

        <td
          class="border border-gray-300 p-2"
          [class.bg-yellow-100]="site.normalizedAddress?.[field.key] != site.matchedAddress?.[field.key]">
          {{ site.matchedAddress?.[field.key] ?? '-' }}
        </td>

        @if (site.dateCheckedByHuman) {
        <td
          class="border border-gray-300 p-2"
          [class.bg-yellow-100]="site.matchedAddress?.[field.key] != site.validatedAddress?.[field.key]">
          {{ site.validatedAddress?.[field.key] ?? '-' }}
        </td>
        }
      </tr>
      }

      <tr>
        <td class="border border-gray-300 p-2"></td>
        <td class="border border-gray-300 p-2"></td>
        <td class="border border-gray-300 p-2"></td>
        <td class="border border-gray-300 p-2">
          Méthode: {{ getMethod() }}<br>
          Niveau de précision: {{ getType() }}<br>
          Score: {{ getScore() | number: '1.2-2' }}%
        </td>
        @if (site.dateCheckedByHuman) {
        <td class="border border-gray-300 p-2">Vérifié manuellement le {{ site.dateCheckedByHuman | date:'dd/MM/yy à HH:mm' }} par {{ site.lastCheckedBy }}</td>
        }
      </tr>
    </tbody>
  </table>
</mat-dialog-content>